'use strict';

export const numericInputsCreatedEvent = 'numericInputsCreated';

let init = function() {
  for (let numericInput of document.body.querySelectorAll('input[type=number]:not(.maxlength-enabled)')) {
    numericInput.classList.add('maxlength-enabled');

    numericInput.addEventListener('input', function() {
      let maxLength = numericInput.getAttribute("maxlength");

      if (maxLength && numericInput.value.length > maxLength) {
        numericInput.value = numericInput.value.slice(0, maxLength);
      }
    });
  }
}

if ('querySelector' in document) {
  init();

  document.body.addEventListener(numericInputsCreatedEvent, () => {
    init();
  });
}
